import { reduce } from 'lodash-es';

export const excludeInactiveCountries = (regionsList, inactiveCountryOptions) => {
  const inactiveCountriesIso = inactiveCountryOptions.map(({ value }) => value);

  return regionsList.map(region => ({
    ...region,
    list: region.list.filter(countryIso => !inactiveCountriesIso.includes(countryIso)),
  }));
};

export const prepareRegionsList = (regionsList, {
  enableWorldwide,
  partialAccess,
}) => {
  const flattenRegionsList = regionsList.reduce((result, region) => {
    if (!region.list.length) return result;

    return result.concat(region);
  }, []);

  const countriesIsoByRegion = flattenRegionsList.reduce((result, { value, list }) => ({
    ...result,
    [value]: list,
  }), {});

  const allCountriesOfRegions = reduce(countriesIsoByRegion, (result, countriesIso, region) => {
    // Exclude Worldwide
    if (region === 'worldwide') return result;

    return result.concat(countriesIso);
  }, []);

  const regionsOptions = (() => {
    const makeOption = ({ value, text, list }) => ({
      value,
      label: text,
      disabled: !list.length || partialAccess,
    });

    const options = regionsList.map(makeOption);

    if (!enableWorldwide) return options.filter(option => option.value !== 'worldwide');

    return options;
  })();

  return {
    flattenRegionsList,
    countriesIsoByRegion,
    allCountriesOfRegions,
    regionsOptions,
  };
};

export const excludeWorldwide = list => list.filter(item => !['worldwide', 'WW'].includes(item));

export const getSelectedRegions = (selectedCountries, {
  countriesIsoByRegion,
}) => {
  const allSelectedRegions = reduce(countriesIsoByRegion, (result, countriesIso, region) => {
    if (new Set([...selectedCountries, ...countriesIso]).size === selectedCountries.length) {
      return [...result, region];
    }

    return result;
  }, []);

  return {
    selectedRegions: allSelectedRegions,
  };
};

export const unpackRegions = (selectedCountries, countriesIsoByRegion) =>
  selectedCountries.reduce((result, slug) => {
    // Check if slug corresponds to a region
    if (countriesIsoByRegion[slug]) {
      return result.concat(countriesIsoByRegion[slug]);
    }

    return [...result, slug];
  }, []);

export const packRegions = (selectedCountries, selectedRegions, countriesIsoByRegion) => {
  const regions = excludeWorldwide(selectedRegions);

  if (!regions.length) return selectedCountries;

  const excludedISOs = regions.reduce((result, region) => (
    result.concat(countriesIsoByRegion[region])
  ), []);


  return [...selectedCountries.filter(iso => !excludedISOs.includes(iso)), ...regions];
};
